import React, { useState } from "react";
import axiosInstance from "../../../api/axios";
import "./resumebook.css";

const getBlobErrorMessage = async (error, fallbackMessage) => {
  const errorData = error?.response?.data;

  if (errorData instanceof Blob) {
    try {
      const text = await errorData.text();
      const parsed = JSON.parse(text);
      return parsed?.message || fallbackMessage;
    } catch {
      return fallbackMessage;
    }
  }

  return errorData?.message || fallbackMessage;
};

const Resumebook = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [messageAll, setMessageAll] = useState("");
  const [downloadFilter, setDownloadFilter] = useState("all");
  const [isDownloadingAll, setIsDownloadingAll] = useState(false);

  const handleDownload = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setMessage("");
    try {
      const response = await axiosInstance.get(
        `/api/resume/download/${email}`,
        { responseType: "blob" }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${email}_resume.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      setMessage("Resume downloaded successfully");
    } catch (error) {
      setErrorMessage(
        await getBlobErrorMessage(error, "Error occurred while downloading resume")
      );
    }
  };

  const handleDownloadAll = async (e) => {
    e.preventDefault();
    setMessageAll("");
    setIsDownloadingAll(true);

    const downloadFilename =
      downloadFilter === "confirmed"
        ? "confirmed_resumes.zip"
        : "all_resumes.zip";

    try {
      const response = await axiosInstance.get(
        `/api/resume/download-all?filter=${downloadFilter}`,
        {
          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", downloadFilename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.setTimeout(() => window.URL.revokeObjectURL(url), 1000);
    } catch (error) {
      setMessageAll(
        await getBlobErrorMessage(
          error,
          "Error occurred while downloading all resumes"
        )
      );
    } finally {
      setIsDownloadingAll(false);
    }
  };

  return (
    <div className="resumebook-page">
      <div className="dashboard">
        <h1 className="ad-dash-title">Resume Book</h1>

        <div className="searches-ad">
          <form onSubmit={handleDownload}>
            <h1 className="title-ad">Download a User's Resume</h1>
            <p>Enter the email of a single user to dowload their resume</p>
            {errorMessage && (
              <p style={{ color: "#c70314", fontSize: 20 }}>{errorMessage}</p>
            )}
            {message && (
              <p style={{ color: "var(--tertiary-color)", fontSize: 20 }}>
                {message}
              </p>
            )}
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter user's email"
              className="find-selector-ad"
              required
            />
            <button className="button-resume" type="submit">
              Download Resume
            </button>
          </form>
        </div>

        <div className="get-users-ad">
          <h1 className="title-ad">Download All Resumes</h1>
          <p>Download a zip file of resumes by applicant group</p>
          <label className="resumebook-filter-label" htmlFor="resume-download-filter">
            Resume group
          </label>
          <select
            id="resume-download-filter"
            className="find-selector-ad resumebook-filter"
            value={downloadFilter}
            onChange={(e) => setDownloadFilter(e.target.value)}
            disabled={isDownloadingAll}
          >
            <option value="all">All applicants</option>
            <option value="confirmed">
              Confirmed only
            </option>
          </select>
          <button
            className="button-resume"
            onClick={handleDownloadAll}
            disabled={isDownloadingAll}
          >
            {isDownloadingAll ? "Downloading..." : "Download All"}
          </button>
          {isDownloadingAll && (
            <p className="resumebook-download-status">
              Preparing the zip file. This can take a moment for larger resume books.
            </p>
          )}
          {messageAll && (
            <p className="resumebook-feedback resumebook-feedback-error">{messageAll}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Resumebook;
